<template>
  <modal
    name="ccvModal"
    resizable
    adaptive
    :clickToClose="false"
    @before-close="checkOrderStatus"
    @before-open="handleBeforeOpen"
    reset
    width="90%"
    height="60%"
    class="roundedmodal"
  >
    <div class="w-full h-full">
      <iframe
        :src="url ? url : paymentUrl"
        class="w-full h-full"
        v-show="
          (!hasError && frameIsLoaded && url) ||
          (!hasError && frameIsLoaded && paymentUrl)
        "
        @load="handleFrameLoad"
        @error="handleFrameError"
        ref="frame"
      />
      <div
        v-if="hasError || paymentError"
        class="h-full w-full flex items-center justify-center"
      >
        <div class="text-center">
          <h2 class="text-4xl">Something went wrong</h2>
          <h4 class="text-2xl">{{ errorMsg }}</h4>
          <ClipLoader v-if="!clickTryAgainButton" color="black" class="mt-8" />
          <Button
            v-if="attempts > 0"
            @click="clickTryAgainButton ? handleTryAgainEvent() : ''"
            class="bg-black text-white mt-6 mr-4"
          >
            Try again ({{ attempts }})
          </Button>
          <Button @click="handleCancelation" class="bg-black text-white mt-6">
            cancel payment
          </Button>
        </div>
      </div>
      <div
        v-if="(!hasError && !url) || (!paymentError && !paymentUrl)"
        class="h-full w-full flex items-center justify-center"
      >
        <div class="text-center">
          <h2 class="text-4xl">{{ lang["please_wait"][language] }}</h2>
          <h4 class="text-3xl">{{ lang["payment_loading"][language] }}</h4>
          <ClipLoader color="black" class="mt-8" />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
const ClipLoader = require("vue-spinner/src/ClipLoader.vue").default;
import lang from "../lang";
import Button from "./Button.vue";
import { GET, getCurrentSessionId } from "../utils";
import axios from 'axios';
export default {
  data() {
    return {
      urlIsLoaded: false,
      frameIsLoaded: false,
      hasError: false,
      url: null,
      timeout: undefined,
      errorMsg: null,
      lang: lang,
      failed: false,
      attempts: 3, // when zero the thing will be reset
      transactionAttempts: 0,
      clickTryAgainButton: true,
      tryAgainModal: false,
      modalClosed:false,
    };
  },
  components: {
    Button,
    ClipLoader,
  },
  computed: {
    ...mapGetters([
      "menuHash",
      "hasKiosk",
      "sessionId",
      "ccvPaying",
      "language",
      "paymentUrl",
      "paymentError",
      "orderData",
    ]),
    ...mapGetters("Cart", ["orderId"]),
    test() {
      return false;
    },
  },
  mounted() {
    /** This is to prevent the idel timer on the CCV payment screen */
    setInterval(() => {
      this.$store.commit('resetIdleTimer', true)      
    }, 5000)
    // console.log("CcvModal is mounted here");

    /** Since component should be controlled with `v-if` prop modal is opened on render */
    this.$modal.show("ccvModal");
    // window.addEventListener("message", this.handleMessageEvent, false);
    if (!this.ccvPaying) {
      this.$store.commit("updateCcvPaying", true);
      this.$emit("initiated");
      this.loadPayment().catch(() => {
        this.hasError = true;
        this.$store.commit("updatePaymentError", true);
        this.cancelTimeout();
      });
    }
  },
  watch: {
    attempts(a) {
      if (a === 0) this.handleError(null, "Ask help from the crew");
    },
  },
  methods: {
    checkOrderStatus() {
      console.log("checkOrderStatus");
      this.modalClosed = true;
      this.$store.dispatch("GET_MENU_ITEMS");
    },
    handleBeforeOpen() { 
      this.modalClosed = false;
      this.reset();
    },
    watchOrderStatus() {
      console.log("watchOrderStatus CcvModal.vue:135");
      let menuHash = this.$route.params.menuHash;
      let sessionId = this.sessionId;
      // const {
      //   data: { OrderAPI },
      // } = await GET.MENU_ITEMS({
      //   menuHash,
      //   sessionId,
      // });
      axios.get(`${process.env.VUE_APP_API_BASE_PATH}/GetMenu?MenuHash=${menuHash}&sessionId=${sessionId}`)
        .then(res => {
        let OrderAPI = res.data.OrderAPI;
        this.$store.commit("updateOrderedData", OrderAPI);
        if (["PaymentFailed", "Paid", "Synced"].includes(OrderAPI.orderStatus)) {
          console.log("payment response is valid ");  
          window.location.replace(`/${menuHash}/0/order-details?sessionId=${sessionId}`);
          // this.$router.push({ name: 'OrderDetails', params: { menuHash: menuHash }, query: { sessionId:sessionId } });
        } else if(!this.modalClosed) {
            console.log("Order status is not Failed or success",OrderAPI);
          setTimeout(() => {
            this.watchOrderStatus();
          }, 3000);
        }
      }).catch(err => {
        console.log(err);
      })

    },
    /** Iframe is loaded */
    handleFrameLoad() {
      console.log("handleFrameLoad CcvModal.vue:164");
      this.frameIsLoaded = true;
      // if (localStorage.getItem("isRetryPayment") == 'true') {
      //   const sessionId = getCurrentSessionId();
      //   const returnUrl = `${window.location.origin}/${this.menuHash}/ccv?sessionId=${sessionId}`;
      //   const orderId = this.orderId;
      //   const registerId = localStorage.getItem("registerId");

      //   GET.INITIATE_TRANSACTION({
      //           sessionId,
      //           orderId,
      //           returnUrl,
      //           paymentTypeId: 8,
      //           registerId,
      //         })
      //           // return the payment if call is resolved
      //     .then(() => { 
      //       this.watchOrderStatus();
      //     }).catch(err => {
      //       console.log(err);
      //     })
      // } else {
      // }

      // start timer
      this.startTimeout();
    },
    /** Error occurs */
    handleError(
      error,
      message = "Something went wrong when loading the payment",
      emitter = true
    ) {
      this.hasError = true;
      this.$store.commit("updatePaymentError", true);
      this.errorMsg = message;
      if (emitter) this.$emit("error", error);
    },
    /** Iframe couldn't be loaded */
    handleFrameError() {
      this.handleError();
    },
    /** Payment was completed */
    handleCompleted(data) {
        try {
        let arr = [];
        arr.push("Trying to handle compelete payment",data);
        arr.push("session Id", this.$route.query.sessionId);
        let dummyData = {
          MenuHash: this.menuHash,
          Dump: JSON.stringify(arr),
        };
        
        axios.post(
          `${process.env.VUE_APP_API_BASE_PATH}/PostErrorDump`,
          dummyData
        );

      } catch (error) {
        // console.error()
      }

      this.$emit("completion", data);
      this.$modal.hide("ccvModal");
    },
    /** Payment was cancelled */
    handleCancelation(data) {
      this.hasError = false;
      this.tryAgainModal = false;
      this.$store.commit("updateCcvPaying", false);
      this.$store.commit("updatePaymentError", false);
      this.$emit("cancelled", data);
      this.$modal.hide("ccvModal");
    },
    /** Payment is pending */
    handlePaymentPending(data) {
      let arr = [];
      arr.push("Trying to handle pending payment",data);
      arr.push("session Id", this.$route.query.sessionId);
      let dummyData = {
        MenuHash: this.menuHash,
        Dump: JSON.stringify(arr),
      };
      
      axios.post(
        `${process.env.VUE_APP_API_BASE_PATH}/PostErrorDump`,
        dummyData
      );

      this.$emit("pending", data);
      this.$modal.hide("ccvModal");
    },
    /** Load payment again */
    handleTryAgainEvent() {
      this.tryAgainModal = true;
      this.clickTryAgainButton = false;
      this.$store.commit("updateCcvPaying", true);
      this.loadPayment()
        .then(() => {
          this.clickTryAgainButton = true;
          //   this.hasError = false;
          this.$store.commit("updatePaymentError", false);
        })
        .catch(() => {
          this.clickTryAgainButton = true;
          this.hasError = true;
          this.$store.commit("updatePaymentError", true);
          this.cancelTimeout();
        });
      this.attempts -= 1;
        // this.$refs.frame.contentWindow.location.reload();
    },
    startTimeout() {
      //   const self = this;
      //   const seconds = 30;handle2
      // Execute timeout handler after x amount of seconds
      //   this.timeout = setTimeout(self.handleTimeout, seconds * 1000);
      //   this.timeOut = setTimeout(() => {
      //     self.handleTimeout;
      //   }, 1000);
    },
    cancelTimeout() {
      clearTimeout(this.timeout);
    },
    /**
     * Payment is taking too long
     * Should start when iframe is loaded
     */
    handleTimeout() {
      this.$emit("timeout");
      this.handleError(null, "It took too long to load the payment", false);
    },
    /**
     * Reset all variables to inital state
     */
    reset() {
      this.urlIsLoaded = false;
      this.frameIsLoaded = false;
      // this.hasError = false;
      this.url = null;
      // this.attempts = 4
      // this.$store.commit("updateCcvPaying", false);
    },
    /**
     * Processes payment based on recieved status from iframe (message event), after payment is initiated
     */
    // handleMessageEvent(event) {
    //   if (event.origin !== window.location.origin) return;
    //   const { data } = event;
    //   // Cancel timeout because payment was initiated
    //   this.cancelTimeout();
    //   // Dont't allow another payment
    //   this.$store.commit("updateCcvPaying", false);
    //   // Generate order detail page url and add to object for handler functions
    //   let orderDetailsUrl = this.generateDetailPageUrl(data);
    //   let returnedData = { ...data, orderDetailsUrl };


    //       try {
    //         let arr = [];
    //         arr.push("iFrame Event listened, received event",event);
    //         arr.push("data",data);
    //         arr.push("return Data",returnedData);
    //         arr.push("session Id", this.$route.query.sessionId);
    //         let dummyData = {
    //           MenuHash: this.menuHash,
    //           Dump: JSON.stringify(arr),
    //         };
            
    //         axios.post(
    //           `${process.env.VUE_APP_API_BASE_PATH}/PostErrorDump`,
    //           dummyData
    //         );
    //         setTimeout(() => {
    //           let arr = [];
    //           arr.push("iFrame Event listened, received event inside setTimeout",event);
    //           arr.push("data",data);
    //           arr.push("return Data",returnedData);
    //           arr.push("session Id", this.$route.query.sessionId);
    //           let dummyData = {
    //             MenuHash: this.menuHash,
    //             Dump: JSON.stringify(arr),
    //           };
              
    //           axios.post(
    //             `${process.env.VUE_APP_API_BASE_PATH}/PostErrorDump`,
    //             dummyData
    //         );

    //         }, 1000);

    //       } catch (error) {
    //         // console.error()
    //       }

    //   switch (data.orderStatus) {
    //     case "Paid": {
    //         let arr = [];
    //         arr.push("iFrame Event listened, received event inside switch Paid case",event);
    //         arr.push("data",data);
    //         arr.push("return Data",returnedData);
    //         arr.push("session Id", this.$route.query.sessionId);
    //         let dummyData = {
    //           MenuHash: this.menuHash,
    //           Dump: JSON.stringify(arr),
    //         };
            
    //         axios.post(
    //           `${process.env.VUE_APP_API_BASE_PATH}/PostErrorDump`,
    //           dummyData
    //         );
          
    //       this.handleCompleted(returnedData);
    //       break;
    //     }
    //     case "PaymentPending": {
    //         let arr = [];
    //         arr.push("iFrame Event listened, received event inside switch case Pending",event);
    //         arr.push("data",data);
    //         arr.push("return Data",returnedData);
    //         arr.push("session Id", this.$route.query.sessionId);
    //         let dummyData = {
    //           MenuHash: this.menuHash,
    //           Dump: JSON.stringify(arr),
    //         };
            
    //         axios.post(
    //           `${process.env.VUE_APP_API_BASE_PATH}/PostErrorDump`,
    //           dummyData
    //         );

    //       this.handlePaymentPending(returnedData);
    //       break;
    //     }
    //     case "Cancelled":
    //       this.handleCancelation(returnedData);
    //       break;
    //     case "PaymentFailed":
    //       this.handleCancelation(returnedData);
    //       break;
    //     default:
    //       break;
    //   }
    //   // this.reset();
    // },
    /** Initiate a payment and return url for the iframe */
    async generatePaymentUrl() {
      /**
       * returnurl is generated based on current location and menu hash
       * `paymentTypeId` is always `8` because component serves for CCV payment method
       */
      const sessionId = getCurrentSessionId();
      const returnUrl = `${window.location.origin}/${this.menuHash}/ccv?sessionId=${sessionId}`;
      const orderId = this.orderId;
      const registerId = localStorage.getItem("registerId");
      return new Promise((resolve, reject) => {
        // first send customer details by patch order
        this.$store
          .dispatch("Cart/UPDATE_ORDER")
          .then(() => {
            // if patch is successful create transaction
              GET.INITIATE_TRANSACTION({
                sessionId,
                orderId,
                returnUrl,
                paymentTypeId: 8,
                registerId,
              })
                // return the payment if call is resolved
                .then(({ data }) => {

                  this.watchOrderStatus();

                  resolve(data.paymentUrl);
                  this.hasError = false;
                  this.$store.commit("updatePaymentError", false);
                  if (this.failed) {
                    this.url = data.paymentUrl;
                    this.$store.commit("updatePaymentUrl", data.paymentUrl);
                  }
                })
                .catch((error) => {
                  this.failed = true;
                  if (this.transactionAttempts < 10) {
                    this.generatePaymentUrl();
                  } else {
                    this.handleError(error);
                  }
                  this.transactionAttempts++;
                  if (this.attempts < 3) {
                    this.handleError(error);
                  }
                  // if (this.attempts !== 0) this.handleError(error);
                  this.reset();
                  reject(error);
                });
          })
          .catch((error) => {
            this.handleError(error);
            this.reset();
            reject(error);
          });
      });
    },
    /** Generates an url for the order details page */
    generateDetailPageUrl({ TableId = 0, MenuHash = this.menuHash }) {
      const sessionId = getCurrentSessionId();
      const sessionParam = "sessionId=" + sessionId;
      const kioskParam = this.hasKiosk ? "mode=kiosk" : "";
      /**
       * Required url query paramters should be added to the array below so they are joined by a ampersand where needed
       * This makes future integration of extra parameters easier
       */
      const urlParams = [sessionParam, kioskParam];
      return `/${MenuHash}/${TableId}/order-details?` + urlParams.join("&");
    },
    /** Gets an iframe url and loads it in the page */
    async loadPayment() {
      const paymentUrl = await this.generatePaymentUrl().catch();
      this.url = await paymentUrl;
      this.$store.commit("updatePaymentUrl", paymentUrl);
      return paymentUrl;
    },
  },
  created() {
    this.$store.commit("updatePaymentUrl", null);
  },

  beforeDestroy() {
    this.$store.commit("updateCcvPaying", false);
    this.$store.commit("updatePaymentError", false);
    clearTimeout(this.timeout);
  },
};
</script>

<style lang="scss"></style>
